<!--
TODO: Component to remove

Used in:
src/eu/app/components/InsuranceVerificationSection.vue|31 col 9| <custom-checkbox
src/eu/app/views/Assessment/QuestionnaireSelfTest/SelfTestActivities.vue|36 col 13| <custom-checkbox
src/eu/app/views/PrescriptionInsurance.vue|126 col 11| <custom-checkbox
src/us/msk/views/Assessment/QuestionnaireSelfTestReevaluations/SelfTestReevaluationsPastConsultations.vue:52
src/us/msk/views/Assessment/QuestionnaireSelfTestReevaluations/SelfTestReevaluationsPastMedication.vue:51
-->

<template>
  <div
    ref="customCheckboxRef"
    :class="getCustomCheckboxCSSClasses"
  >
    <input
      :id="name"
      :checked="checked"
      :data-qa="dataQA"
      :data-qa-value="dataQAValue"
      :value="value"
      class="custom-checkbox__input js-custom-checkbox__input"
      type="checkbox"
      @blur="handleBlurEvent"
      @change="handleChangeEvent"
      @click="handleClickEvent"
      @focus="handleFocusEvent"
    />
  </div>
</template>

<script setup>
import { computed, ref } from 'vue'

const ENTER = 13

defineOptions({
  inheritAttrs: false,
})

const props = defineProps({
  name: {
    type: String,
    default: '',
  },
  value: {
    type: String,
    default: '',
  },
  checked: {
    type: Boolean,
    default: false,
  },
  dataQA: {
    type: String,
    default: '',
  },
  dataQAValue: {
    type: String,
    default: '',
  },
})

const customCheckboxRef = ref(null)

const emit = defineEmits(['change', 'focus', 'blur'])

const focused = ref(false)

const getCustomCheckboxCSSClasses = computed(() => {
  const classes = ['custom-checkbox']

  if (props.checked) {
    classes.push('custom-checkbox--checked')
  }

  if (focused.value) {
    classes.push('custom-checkbox--focused')
  }

  return classes
})

const handleChangeEvent = (event) => {
  const { checked, value } = event.target
  emit('change', {
    checked,
    value,
  })
}

const handleFocusEvent = () => {
  focused.value = true
  emit('focus')

  customCheckboxRef.value.addEventListener('keydown', handleKeyDownEvent)
}

const handleBlurEvent = () => {
  focused.value = false
  emit('blur')

  customCheckboxRef.value.removeEventListener('keydown', handleKeyDownEvent)
}

const handleClickEvent = (event) => {
  event.target.focus()
}

const handleKeyDownEvent = (event) => {
  if (event.keyCode === ENTER) {
    customCheckboxRef.value.querySelector('.checkbox--input').click()
  }
}
</script>

<style lang="scss">
.custom-checkbox {
  position: relative;
  width: 100%;
  height: 100%;
  box-sizing: border-box;
  border: 1px solid $kds-color-line-subtle;
  border-radius: 3px;

  &__input {
    position: absolute;
    margin: 0;
    padding: 0;
    width: 100%;
    height: 100%;
    opacity: 0;
    cursor: pointer;
  }

  &--checked {
    background-color: $kds-color-background-interactive-accent;
    border: 1px solid $kds-color-background-interactive-accent;
    background-image: url(@shared/assets/img/checkbox.svg);
    background-position: 50% 50%;
    background-repeat: no-repeat;
    background-size: 60%;
  }

  &--focused {
    border-color: $kds-color-background-interactive-accent;
  }
}
</style>
